import React from "react";
import { Box, Typography, Chip, Stack } from "@mui/material";
import PublisherComment from "../Home/PublisherComment";
import ChipList from "../common/ChipList";
import { styled } from "@mui/material/styles";

const ContentBox = styled(Box)(({ theme }) => ({
  width: "100%",
  marginBottom: theme.spacing(1.5),
  padding: "10px 14px",
  background: "rgba(255,255,255,0.4)",
  backdropFilter: "blur(10px)",
  borderRadius: "10px",
  border: "1px solid rgba(226,232,240,0.3)",
  "& .publisher-comment": {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "rgba(71,85,105,0.9)",
    fontWeight: 400,
  },
}));

const TagsBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  "& .MuiChip-root": {
    margin: theme.spacing(0.25),
    background: "rgba(139,92,246,0.1)",
    color: "rgba(139,92,246,0.8)",
    border: "1px solid rgba(139,92,246,0.2)",
    borderRadius: "8px",
    fontSize: "11px",
    fontWeight: 500,
    height: "22px",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      background: "rgba(139,92,246,0.15)",
      borderColor: "rgba(139,92,246,0.3)",
      transform: "translateY(-1px)",
      boxShadow: "0 2px 8px rgba(139,92,246,0.2)",
    },
    "&.highlighted": {
      background: "linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)",
      color: "white",
      borderColor: "rgba(255,255,255,0.2)",
      boxShadow: "0 2px 8px rgba(139,92,246,0.3)",
    },
  },
}));

const StatsBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  padding: "10px 14px",
  background: "linear-gradient(135deg, rgba(16,185,129,0.1) 0%, rgba(34,197,94,0.1) 100%)",
  border: "1px solid rgba(16,185,129,0.2)",
  borderRadius: "10px",
  "& .stats-text": {
    fontSize: "14px",
    fontWeight: 700,
    color: "rgba(16,185,129,0.9)",
  },
}));

const CollectionTitleBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  padding: "10px 14px",
  background: "linear-gradient(135deg, rgba(139,92,246,0.1) 0%, rgba(168,85,247,0.1) 100%)",
  border: "1px solid rgba(139,92,246,0.2)",
  borderRadius: "10px",
  "& .title-text": {
    fontSize: "14px",
    fontWeight: 700,
    color: "rgba(139,92,246,0.9)",
    lineHeight: 1.3,
  },
}));

const CollectionCardBody = ({ data, searhTags, onMenuAction }) => {
  const hasTitle = data.name;
  const hasDescription = data.description;
  const hasTags = data.keywords && data.keywords.length > 0;
  const hasStats = data.rates_count;

  return (
    <Box>
      {/* Collection Title */}
      {hasTitle && (
        <Box sx={{ mb: 1.5 }}>
          <Typography 
            variant="h6"
            sx={{ 
              fontSize: '16px',
              fontWeight: 700,
              color: 'rgba(30,41,59,0.9)',
              lineHeight: 1.3,
              mb: 1
            }}
          >
            {data.name}
          </Typography>
        </Box>
      )}

      {/* Description */}
      {hasDescription && (
        <ContentBox>
          <PublisherComment 
            comment={data.description} 
            onClickDisabled 
          />
        </ContentBox>
      )}

      {/* Collection Stats */}
      {hasStats && (
        <Box sx={{ mb: 1.5 }}>
          <Typography 
            variant="caption" 
            sx={{ 
              color: 'rgba(16,185,129,0.8)',
              fontWeight: 600,
              fontSize: '10px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              mb: 0.5,
              display: 'block'
            }}
          >
            Items
          </Typography>
          <StatsBox>
            <Typography className="stats-text">
              {data.rates_count} items in collection
            </Typography>
          </StatsBox>
        </Box>
      )}

      {/* Tags Section - Only show heading when there are tags */}
      {hasTags && (
        <Box sx={{ mb: 1.5 }}>
          <Typography 
            variant="caption" 
            sx={{ 
              color: 'rgba(139,92,246,0.8)',
              fontWeight: 600,
              fontSize: '10px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              mb: 0.5,
              display: 'block'
            }}
          >
            Topics
          </Typography>
          <TagsBox>
            <ChipList 
              list={data.keywords} 
              highlightList={searhTags} 
              AllowChipOverflow 
            />
          </TagsBox>
        </Box>
      )}
    </Box>
  );
};

export default CollectionCardBody;
